module.exports = ":host {\n  position: relative; }\n  :host .tinymce-edit-component {\n    border: 1px solid #e1e1e1;\n    position: relative; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/sn-tiny-editor/sn-tiny-editor.scss
// module id = ./web/modern/components/common/sn-tiny-editor/sn-tiny-editor.scss
// module chunks = 0